import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import { useDispatch, useSelector } from "react-redux";
import MyAppointments from "../app/patient-area/MyAppointments";
import MyAccounts from "../app/patient-area/MyAccounts";
import MyHistory from "../app/patient-area/MyHistory";
import MyProfile from "../app/patient-area/MyProfile";
import MySettings from "../app/patient-area/MySettings";
import HomePatientArea from "../app/patient-area/HomePatientArea";
import LockOpenIcon from "@material-ui/icons/LockOpen";
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";
//import { useTheme } from "@material-ui/core/styles";
import Avatar from "@material-ui/core/Avatar";
import PersonSharpIcon from "@material-ui/icons/PersonSharp";
import PeopleSharpIcon from "@material-ui/icons/PeopleSharp";
import UpdateSharpIcon from "@material-ui/icons/UpdateSharp";
import SettingsSharpIcon from "@material-ui/icons/SettingsSharp";
import HomeIcon from "@material-ui/icons/Home";
import TodayIcon from "@material-ui/icons/Today";
import CloudDownloadIcon from "@material-ui/icons/CloudDownload";

import {
  getAllInfoUser,
  getFiles,
  getHistory,
  getLinkedAccounts,
  getListAppointments,
  logOut,
  initValues,
  getRecallStatus,
  getNewslettersStatus,
  getRecallDocument,
  getRecallShare,
  getRecallCommunication
} from "../utils/fetcher";
import { translator } from "../utils/i18n";
import Tooltip from "@material-ui/core/Tooltip";
import CloseIcon from "@material-ui/icons/Close";
import FooterPatientArea from "../app/patient-area/FooterPatientArea";
import MyFiles from "../app/patient-area/MyFiles";
import { closeMainDialog, startLoading, stopLoading } from "../actions";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <Typography
      component="div"
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      <Box p={4}>{children}</Box>
    </Typography>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired
};

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    "aria-controls": `vertical-tabpanel-${index}`
  };
}

const useStyles = makeStyles(() => ({
  root: {
    flexGrow: 1,
    display: "flex",
    height: 550
  }
}));

export default function PatientArea() {
  const classes = useStyles();
  const [value, setValue] = useState(0);
  const [setOpen] = React.useState(false);
  const config = useSelector(state => state.configuration);

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const dispatch = useDispatch();
  const listAppointments = async () => await dispatch(getListAppointments());
  const linkedAccounts = async () => await dispatch(getLinkedAccounts());
  const history = async () => await dispatch(getHistory());
  const allInfoUser = async () => await dispatch(getAllInfoUser());
  const logOutFunc = async () => await dispatch(logOut());
  const files = async () => await dispatch(getFiles());
  const recall = async () => await dispatch(getRecallStatus());
  const recallDocument = async () => await dispatch(getRecallDocument());
  const recallShare = async () => await dispatch(getRecallShare());
  const recallCommunication = async () =>
    await dispatch(getRecallCommunication());
  const newsletter = async () => await dispatch(getNewslettersStatus());
  const recallParams = async () => {
    await recall();
    await recallDocument();
    await recallShare();
    await recallCommunication();
    await newsletter();
    dispatch(stopLoading());
  };
  const lastNameUser = useSelector(state =>
    state.user.userData ? state.user.userData.lastName : ""
  );
  const isLoading = useSelector(state => state.loader.isLoading);

  const firstNameUser = useSelector(state =>
    state.user.userData ? state.user.userData.firstName : ""
  );

  useEffect(() => {
    listAppointments();
  }, []);

  const handleChange = async (event, newValue) => {
    if (isLoading) return;
    dispatch(startLoading());
    switch (newValue) {
      case 0:
        await listAppointments();
        break;
      case 1:
        await listAppointments();
        break;
      case 2:
        await linkedAccounts();
        break;
      case 3:
        await history();
        break;
      case 4:
        await files();
        break;
      case 5:
        await allInfoUser();
        break;
      case 6:
        await allInfoUser();
        if (config.showUserParams) {
          await recallParams();
        }
        break;
      case 7:
        logOutFunc();
        break;
      default:
        console.log("default");
    }
    await setValue(newValue);
  };

  const noClose = initValues().noClose;

  const closeApp = () => {
    window.parent.postMessage({ event_id: "closeiframe" }, "*");
    dispatch(closeMainDialog());
  };

  return (
    <div className={classes.root}>
      {!noClose && (
        <Tooltip
          className="close-custom-btn"
          title={translator()._("W_STEP_BOUTON_FERMER")}
        >
          <IconButton
            aria-label={translator()._("W_STEP_BOUTON_FERMER")}
            onClick={closeApp}
          >
            <CloseIcon />
          </IconButton>
        </Tooltip>
      )}
      <div className="wrap-tab">
        <IconButton
          color="inherit"
          aria-label="open drawer"
          onClick={handleDrawerOpen}
          edge="start"
          className="btn-toggle-menu"
        >
          <MenuIcon />
        </IconButton>

        <div className="bloc-head-widget">
          <Tooltip
            title={`${translator()._("W_BONJOUR")} ${lastNameUser}`}
            placement="right"
            className="item"
          >
            <Avatar className="avatar-blue margin-auto avatar-xxl">
              {lastNameUser.length > 0 ? lastNameUser.charAt(0) : ""}
              {firstNameUser.length > 0 ? firstNameUser.charAt(0) : ""}
            </Avatar>
          </Tooltip>
        </div>

        <Tabs
          orientation="vertical"
          variant="scrollable"
          value={value}
          onChange={handleChange}
          aria-label={translator()._("CP_TITLE")}
          root="wrap-custom-tab"
          TabIndicatorProps={{
            style: {
              backgroundColor: "#009eff",
              left: 0
            }
          }}
        >
          <Tab
            className="custom-tab"
            label={
              <span className="title-tab">
                {translator()._("CP_MENU_HOME")}
              </span>
            }
            icon={<HomeIcon />}
            {...a11yProps(0)}
          />
          <Tab
            className="custom-tab"
            label={
              <span className="title-tab">
                {translator()._("CP_MENU_MES_RDV")}
              </span>
            }
            icon={<TodayIcon />}
            {...a11yProps(1)}
          />
          <Tab
            className="custom-tab"
            label={
              <span className="title-tab">
                {translator()._("CP_MENU_COMPTES_LIES")}
              </span>
            }
            icon={<PeopleSharpIcon />}
            {...a11yProps(2)}
          />
          <Tab
            className="custom-tab"
            label={
              <span className="title-tab">
                {translator()._("CP_MENU_HISTORIQUE")}
              </span>
            }
            icon={<UpdateSharpIcon />}
            {...a11yProps(3)}
          />
          <Tab
            className="custom-tab"
            label={
              <span className="title-tab">
                {translator()._("CP_MENU_DOCUMENTS")}
              </span>
            }
            icon={<CloudDownloadIcon />}
            {...a11yProps(4)}
          />
          <Tab
            className="custom-tab"
            label={
              <span className="title-tab">
                {translator()._("CP_MENU_PROFIL")}
              </span>
            }
            icon={<PersonSharpIcon />}
            {...a11yProps(5)}
          />
          <Tab
            className="custom-tab"
            label={
              <span className="title-tab">
                {translator()._("CP_MENU_PARAMETRES")}
              </span>
            }
            icon={<SettingsSharpIcon />}
            {...a11yProps(6)}
          />
          <Tab
            className="custom-tab"
            label={
              <span className="title-tab">
                {translator()._("W_STEP_BOUTON_DECONNECTER")}
              </span>
            }
            icon={<LockOpenIcon />}
            {...a11yProps(7)}
          />
        </Tabs>
      </div>
      <div className="wrap-custom-tab-panel">
        {isLoading && (
          <div className="wrap-circular-progress">
            <div className="la-ball-spin-fade-rotating la-2x">
              <div />
              <div />
              <div />
              <div />
              <div />
              <div />
              <div />
              <div />
            </div>
          </div>
        )}
        <TabPanel className="custom-tab-panel" value={value} index={0}>
          <HomePatientArea handleChange={e => handleChange(e, 1)} />
        </TabPanel>
        <TabPanel className="custom-tab-panel" value={value} index={1}>
          <MyAppointments />
        </TabPanel>
        <TabPanel className="custom-tab-panel" value={value} index={2}>
          <MyAccounts />
        </TabPanel>
        <TabPanel className="custom-tab-panel" value={value} index={3}>
          <MyHistory />
        </TabPanel>
        <TabPanel className="custom-tab-panel" value={value} index={4}>
          <MyFiles />
        </TabPanel>
        <TabPanel className="custom-tab-panel" value={value} index={5}>
          <MyProfile />
        </TabPanel>
        <TabPanel className="custom-tab-panel" value={value} index={6}>
          <MySettings showConfigs={config.showUserParams} />
        </TabPanel>
        <FooterPatientArea />
      </div>
    </div>
  );
}
